/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JourneyForUserSegment
 */
export interface JourneyForUserSegment {
    /**
     * 
     * @type {string}
     * @memberof JourneyForUserSegment
     */
    questConfigId: string;
    /**
     * The segment quest's name (e.g. "Boot Camp").
     * @type {string}
     * @memberof JourneyForUserSegment
     */
    name: string;
    /**
     * Kicker rendered above the name on the segment masthead (e.g. "Get in the Game").
     * @type {string}
     * @memberof JourneyForUserSegment
     */
    groupLabel?: string;
    /**
     * Zero-based position of this segment along the track, derived from the prerequisite edge graph. Segments that unlock in parallel (branch alternates) share an order.
     * @type {number}
     * @memberof JourneyForUserSegment
     */
    order: number;
}

/**
 * Check if a given object implements the JourneyForUserSegment interface.
 */
export function instanceOfJourneyForUserSegment(value: object): value is JourneyForUserSegment {
    if (!('questConfigId' in value) || value['questConfigId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function JourneyForUserSegmentFromJSON(json: any): JourneyForUserSegment {
    return JourneyForUserSegmentFromJSONTyped(json, false);
}

export function JourneyForUserSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyForUserSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'questConfigId': json['questConfigId'],
        'name': json['name'],
        'groupLabel': json['groupLabel'] == null ? undefined : json['groupLabel'],
        'order': json['order'],
    };
}

export function JourneyForUserSegmentToJSON(json: any): JourneyForUserSegment {
    return JourneyForUserSegmentToJSONTyped(json, false);
}

export function JourneyForUserSegmentToJSONTyped(value?: JourneyForUserSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questConfigId': value['questConfigId'],
        'name': value['name'],
        'groupLabel': value['groupLabel'],
        'order': value['order'],
    };
}

